import { Pipe, PipeTransform } from '@angular/core';

import { Variable, VariableSummary } from '@mtna/pojo-consumer-ui';
import { TabulationClassification } from '@mtna/rds-base-ui';

import { RdsCodeDisplayType } from '../core/models/code-display-type.model';
import { RdsGetDatumValuePipe } from './get-datum-value.pipe';
import { DatumCell } from './models/datum-cell.model';

@Pipe({
  name: 'rdsGetHeaderCellValue'
})
export class RdsGetHeaderCellValuePipe implements PipeTransform {
  constructor(private datumValuePipe: RdsGetDatumValuePipe) {}
  transform(
    displayType: RdsCodeDisplayType,
    value: DatumCell,
    columnLookupLength: number,
    variables: Array<Variable | VariableSummary>,
    classifications: { [id: string]: TabulationClassification },
    map: { [id: string]: string[] },
    measureColumnHeader: string
  ): string {
    if (value.subtotal && value.id === 'row-total') {
      return columnLookupLength ? 'TOTAL' : measureColumnHeader;
    } else if (value.subtotal) {
      return 'Subtotal';
    } else {
      return this.datumValuePipe.transform(displayType, value.datumStack[value.datumStack.length - 1], variables, classifications, map);
    }
  }
}
